
import orders from "@/store/modules/entitled/orders";
import logGuardPost from "@/store/modules/entitled/logGuardPost"
import logStatus from "@/store/modules/entitled/logStatus"
import visitors from "@/store/modules/entitled/visitors";
import guard from "@/store/modules/entitled/guard";
import organizations from "@/store/modules/entitled/organizations";
import guardPosts from "@/store/modules/entitled/guardposts";
import regularPasses from "@/store/modules/entitled/regularpasses";
import bans from "@/store/modules/entitled/bans";
import fouls from "@/store/modules/entitled/fouls";

export default {
    namespaced: true,
    modules: {
        visitors,
        orders,
        logGuardPost,
        logStatus,
        guard,
        organizations,
        guardPosts,
        regularPasses,
        bans,
        fouls
    }
}
